export const SET_LOADING = 'SET_LOADING'
export const GET_LAST_ACTIVITY_REPORT = 'GET_LAST_ACTIVITY_REPORT'
